export default __webpack_public_path__ + "static/media/youtube.20d6df9f.svg";